import { createTranslations } from '@npco/common-utils-translations'

export const bpayDetailsFieldTranslations = createTranslations({
  label: 'BPAY Details',
  errorRequired: 'BPAY Details are required.',
  addBpayDetails: 'Add BPAY Details',
  addBpayDetailsButtonLabel: '+ Add BPAY Details',
  successMessage: 'BPAY Details have been added.',
})
